
<mat-card class="filter settingHeader">
  <div class="name">
    Document Templates
  </div>
  <div class="quickAction">
    
    <!-- <mat-form-field appearance="" >
      <mat-label>Search items in tags</mat-label>
      <input matInput type="text" [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field> -->

  </div>
</mat-card>

<div class="documents">
  <mat-card class="example-list rowholder" *ngIf="!ShowNoRecordFound">
    <div class="fieldRow head">
      <span class="moveicon"></span>
      <span class="fieldName">Template Name</span> 
     
      <span class="fieldName">Type</span>    
      <span class="delete">Delete</span>
    </div>
    <div class="example-box fieldRow" *ngFor="let temp of templateList">
      <span class="moveicon"></span>
      <span class="fieldName">{{temp.templateName}}</span>

     

      <span class="fieldName">{{temp.moduleName}}</span>
      <span class="delete">
        <button mat-icon-button class="trash" (click)="deleteTemplate(temp)">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </span>
    </div>
    <!-- (click)="deleteTags(temp)" -->
    <!-- <mat-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons [length]="paginatorTotalLength" 
    (page)="CallNextPrevPageData($event)">
     </mat-paginator> -->
   
  </mat-card>

  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>

</div>




<app-loader></app-loader>